var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"pr-md-12",attrs:{"cols":"12","md":"6","sm":"12"}},[_vm._t("left")],2),_c('v-col',{staticClass:"separator-border-left pl-md-12",attrs:{"cols":"12","md":"6","sm":"12"}},[_vm._t("right")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }